import { combineReducers } from '@reduxjs/toolkit';

import { cfdReducer } from './cfd';
import { connectionReducer } from './connection';
import { displaysReducer } from './displays';
import { hydrateStore } from './helpers/hydrate-store';
import { hubReducer } from './hub';
import { printersReducer } from './printers';
import { receiptReducer } from './receipt';

const rootReducer = combineReducers({
  hub: hubReducer,
  cfd: cfdReducer,
  connection: connectionReducer,
  receipt: receiptReducer,
  displays: displaysReducer,
  printers: printersReducer,
});

type RootReducer = typeof rootReducer;
type State = ReturnType<RootReducer>;

const getMainReducer =
  (reducer: RootReducer): RootReducer =>
  (state, action) => {
    if (hydrateStore.match(action) && action.payload) return action.payload as State;

    return reducer(state, action);
  };

const mainReducer = getMainReducer(rootReducer);

export { mainReducer };
